<template>
    <div v-tooltip="tooltip">
        <toggle-button
            switch-color="#FFFFFF"
            :width="40"
            :height="20"
            :color="colors"
            :sync="true"
            :value="value"
            :disabled="disabled"
            @change="(evt) => $emit('input', evt.value)"
        ></toggle-button>
    </div>
</template>

<script>
import ToggleButton from "vue-js-toggle-button/src/Button";
import provider from "@mixins/provider";

export default {
    components: {
        ToggleButton,
    },

    data() {
        return {};
    },

    props: {
        value: {
            type: Boolean,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        tooltip: {
            type: String,
            required: false,
        },
    },

    mixins: [provider],

    computed: {
        colors() {
            const colors = {
                checked: this.providerColor,
                unchecked: "#E3E3E3",
                disabled: "#CCCCCC",
            };

            return colors;
        },
    },
};
</script>

<style scoped></style>
